__turbopack_context__.v({
  "checkbox": "Checkbox-module__oSwJeG__checkbox",
  "checkbox--lg": "Checkbox-module__oSwJeG__checkbox--lg",
  "checkbox--md": "Checkbox-module__oSwJeG__checkbox--md",
  "checkbox--sm": "Checkbox-module__oSwJeG__checkbox--sm",
  "checkboxContainer": "Checkbox-module__oSwJeG__checkboxContainer",
  "checkedState": "Checkbox-module__oSwJeG__checkedState",
  "indeterminateState": "Checkbox-module__oSwJeG__indeterminateState",
  "label": "Checkbox-module__oSwJeG__label",
});
